import { createActions } from './createActions.ts';
import { deleteActions } from './deleteActions.ts';
import { fetchActions } from './fetchActions.ts';

/**
 * Combined actions object for the snippets store.
 * Actions are grouped by concern for better organization and testability:
 * - fetchActions: Data fetching and cache management
 * - createActions: Snippet creation with UI integration (flags, quick insert)
 * - deleteActions: Snippet deletion (API + local state; pass editorAPI in options for quick insert removal)
 */
export const actions = {
	...fetchActions,
	...createActions,
	...deleteActions,
};
